/**
 * Do not edit directly
 */
export const darkTheme = {
  "semantic": {
    "brand": {
      "default": {
        "primary": "#93c5fd",
        "secondary": "#60a5fa",
        "subtle": "#1e3a8a",
        "muted": "#1e40af",
        "light": "#065492",
        "soft": "#1659cb",
        "moderate": "#3b82f6",
        "strong": "#bfdbfe"
      },
      "danger": {
        "primary": "#f87171",
        "inverse": "#7f1d1d",
        "subtle": "#991b1b",
        "light": "#b91c1c",
        "muted": "#dc2626"
      }
    },
    "text": {
      "primary": "#fafafa",
      "secondary": "#a3a3a3",
      "tertiary": "#737373",
      "subtle": "#404040",
      "soft": "#525252",
      "inverse": "#171717"
    },
    "background": {
      "neutral": {
        "primary": "#262626",
        "secondary": "#171717",
        "subtle": "#404040",
        "soft": "#525252",
        "strong": "#737373",
        "strongL1": "#a3a3a3",
        "strongL2": "#d4d4d4",
        "inverse": "#f5f5f5"
      }
    },
    "border": {
      "primary": "#525252",
      "secondary": "#a3a3a3",
      "subtle": "#404040",
      "strong": "#737373",
      "soft": "#262626",
      "inverse": "#171717"
    },
    "accent": {
      "cyan": {
        "subtle": "#164e63",
        "soft": "#155e75",
        "muted": "#0e7490",
        "moderate": "#0891b2",
        "bold": "#06b6d4",
        "strong": "#22d3ee",
        "primary": "#67e8f9",
        "inverse": "#f4f9fa"
      },
      "tan": {
        "subtle": "#d4c5a9",
        "soft": "#eed3ab",
        "muted": "#f5f5f5",
        "strong": "#f9f9f9"
      },
      "inverse": {
        "subtle": "#e5e5e5",
        "soft": "#d4d4d4",
        "strong": "#a3a3a3",
        "primary": "#f5f5f5",
        "secondary": "#fafafa",
        "inverse": "#262626"
      },
      "green": {
        "subtle": "#14532d",
        "soft": "#166534",
        "muted": "#16a34a",
        "bold": "#22c55e",
        "strong": "#4ade80",
        "primary": "#86efac",
        "inverse": "#f0fdf4"
      },
      "orange": {
        "subtle": "#7c2d12",
        "soft": "#9a3412",
        "muted": "#ea580c",
        "strong": "#f97316",
        "primary": "#fdba74",
        "inverse": "#fff7ed"
      },
      "purple": {
        "subtle": "#581c87",
        "soft": "#6b21a8",
        "muted": "#9333ea",
        "bold": "#a855f7",
        "strong": "#c084fc",
        "primary": "#d8b4fe",
        "inverse": "#faf5ff"
      },
      "blue": {
        "subtle": "#1e3a8a",
        "soft": "#1e40af",
        "muted": "#1659cb",
        "bold": "#3b82f6",
        "strong": "#60a5fa",
        "primary": "#93c5fd",
        "inverse": "#eff6ff"
      },
      "yellow": {
        "subtle": "#713f12",
        "soft": "#854d0e",
        "bold": "#eab308",
        "muted": "#eab308",
        "strong": "#facc15",
        "primary": "#fef08a",
        "inverse": "#fefce8"
      },
      "red": {
        "subtle": "#7f1d1d",
        "soft": "#991b1b",
        "muted": "#dc2626",
        "bold": "#ef4444",
        "strong": "#f87171",
        "primary": "#fca5a5",
        "inverse": "#fef2f2"
      },
      "pink": {
        "subtle": "#831843",
        "soft": "#9d174d",
        "muted": "#db2777",
        "bold": "#ec4899",
        "strong": "#f472b6",
        "primary": "#f9a8d4",
        "inverse": "#fdf2f8"
      }
    }
  }
};
